// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/* istanbul ignore next */
import type { AGCOptions } from '../../libs/voicefocus/types';

// Barrelizer re-export, assemble!
export default AGCOptions;
